



































































































































































































import Vue from 'vue';

import Requester from '../../requester';

import { Consulta } from '../../../../back/src/entity/Consulta';
import { Paciente } from '../../../../back/src/entity/Paciente';
import { ConsultaPutFormData } from '../../../../back/src/types';
import { awsS3URL } from '../../utils/constants';

import ThePacientesAvisosTabela from './ThePacientesAvisosTabela.vue';

export default Vue.extend({
  name: 'PacienteConsultaColetivaCard',
  props: {
    paciente: {
      type: Object as () => Paciente,
    },
    consulta: {
      type: Object as () => Consulta,
    },
    dentroDoModal: {
      default: false,
    },
  },
  components: {
    ThePacientesAvisosTabela,
  },
  data() {
    return {
      loadingPresenca: false,
    };
  },
  computed: {
    pesoKilos() {
      if (this.consulta.peso_gramas) {
        const pesoKg = this.consulta.peso_gramas / 1000;
        return new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(pesoKg);
      }
      return '';
    },
    freqCardiaca() {
      return this.consulta.freq_card_materna || '';
    },
    fotoURL() {
      return this.paciente.foto_aws_key ? `${awsS3URL}${this.paciente.foto_aws_key}` : null;
    },
  },
  methods: {
    async confirmaPresenca() {
      this.loadingPresenca = true;
      const formData: ConsultaPutFormData = {
        id: this.consulta.id,
        presenca_consulta_coletiva: true,
      };
      try {
        const response = await Requester.consulta.alteraConsulta(formData);
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          this.$emit('atualiza-consulta', formData.id);
          this.$root.$emit('avisoSnackbar', { color: 'success', text: 'Presença confirmada!' });
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loadingPresenca = false;
      }
    },
  },
});
